@import "tailwindcss";

:root {
  --color-primary: #F59E0B;
  --color-on-primary: #0F172A;
  --color-secondary: #FBBF24;
  --color-accent: #2563EB;
  --color-background: #FFFBEB;
  --color-foreground: #78350F;
  --color-muted: #F1F2EF;
  --color-border: #FDE68A;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Chakra Petch', system-ui, sans-serif;
  background-color: var(--color-background);
  color: var(--color-foreground);
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Russo One', system-ui, sans-serif;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
